import React from "react"
import Layout from "../components/layout/layout"
import ContactUsComponent from "../components/ContactUs/ContactUs.jsx"

const ContactUs = () => (
  <Layout headerType="newClinicianHeader" footerType="newFooter">
    <ContactUsComponent />
  </Layout>
)

export default ContactUs
